import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

import type { ViewCommand } from '../types';
import { resolveViewCommand } from '../viewCommands';
import { ArrowIcon } from '../icons';

/*
 * Clickable view-command chip (used when the panel is not focused, so we don't
 * auto-navigate). Outlined navy pill that inverts on hover. Unknown command
 * types resolve to null and render nothing. The target route is prefetched on
 * mount so the click navigates without waiting for the bundle/data.
 */
const ViewCommandChip = ({ command }: { command: ViewCommand }) => {
  const router = useRouter();
  const resolved = resolveViewCommand(command);
  const href = resolved?.href;

  useEffect(() => {
    if (href) router.prefetch(href).catch(() => {});
  }, [href, router]);

  if (!resolved) return null;
  return (
    <button
      type="button"
      className="bra-viewcmd"
      onClick={() => router.push(resolved.href)}
    >
      <span>{resolved.label}</span>
      <ArrowIcon />
    </button>
  );
};

export default ViewCommandChip;
